// extracted by mini-css-extract-plugin
module.exports = {"button":"ButtonList_button__1Qurt","newButtons":"ButtonList_newButtons__2q_Ej","removeButton":"ButtonList_removeButton__Zco6E"};